// ISO 4217 List One — unique alphabetic codes (entity rows deduped by code).
// Source: SIX Group List One (Current Currency & Funds). AUD / NZD / USD pinned first.
// Excludes fund / accounting / index / unit codes (BOV, CHE, CHW, CLF, COU, MXV, USN, UYI, UYW, XAD, XDR, XSU, XUA, VED).
export const isoCurrencies = [
  { name: 'AUD — Australian Dollar', value: 'AUD' },
  { name: 'NZD — New Zealand Dollar', value: 'NZD' },
  { name: 'USD — US Dollar', value: 'USD' },
  { name: 'AED — UAE Dirham', value: 'AED' },
  { name: 'AFN — Afghani', value: 'AFN' },
  { name: 'ALL — Lek', value: 'ALL' },
  { name: 'AMD — Armenian Dram', value: 'AMD' },
  { name: 'AOA — Kwanza', value: 'AOA' },
  { name: 'ARS — Argentine Peso', value: 'ARS' },
  { name: 'AWG — Aruban Florin', value: 'AWG' },
  { name: 'AZN — Azerbaijan Manat', value: 'AZN' },
  { name: 'BAM — Convertible Mark', value: 'BAM' },
  { name: 'BBD — Barbados Dollar', value: 'BBD' },
  { name: 'BDT — Taka', value: 'BDT' },
  { name: 'BHD — Bahraini Dinar', value: 'BHD' },
  { name: 'BIF — Burundi Franc', value: 'BIF' },
  { name: 'BMD — Bermudian Dollar', value: 'BMD' },
  { name: 'BND — Brunei Dollar', value: 'BND' },
  { name: 'BOB — Boliviano', value: 'BOB' },
  { name: 'BRL — Brazilian Real', value: 'BRL' },
  { name: 'BSD — Bahamian Dollar', value: 'BSD' },
  { name: 'BTN — Ngultrum', value: 'BTN' },
  { name: 'BWP — Pula', value: 'BWP' },
  { name: 'BYN — Belarusian Ruble', value: 'BYN' },
  { name: 'BZD — Belize Dollar', value: 'BZD' },
  { name: 'CAD — Canadian Dollar', value: 'CAD' },
  { name: 'CDF — Congolese Franc', value: 'CDF' },
  { name: 'CHF — Swiss Franc', value: 'CHF' },
  { name: 'CLP — Chilean Peso', value: 'CLP' },
  { name: 'CNY — Yuan Renminbi', value: 'CNY' },
  { name: 'COP — Colombian Peso', value: 'COP' },
  { name: 'CRC — Costa Rican Colon', value: 'CRC' },
  { name: 'CUP — Cuban Peso', value: 'CUP' },
  { name: 'CVE — Cabo Verde Escudo', value: 'CVE' },
  { name: 'CZK — Czech Koruna', value: 'CZK' },
  { name: 'DJF — Djibouti Franc', value: 'DJF' },
  { name: 'DKK — Danish Krone', value: 'DKK' },
  { name: 'DOP — Dominican Peso', value: 'DOP' },
  { name: 'DZD — Algerian Dinar', value: 'DZD' },
  { name: 'EGP — Egyptian Pound', value: 'EGP' },
  { name: 'ERN — Nakfa', value: 'ERN' },
  { name: 'ETB — Ethiopian Birr', value: 'ETB' },
  { name: 'EUR — Euro', value: 'EUR' },
  { name: 'FJD — Fiji Dollar', value: 'FJD' },
  { name: 'FKP — Falkland Islands Pound', value: 'FKP' },
  { name: 'GBP — Pound Sterling', value: 'GBP' },
  { name: 'GEL — Lari', value: 'GEL' },
  { name: 'GHS — Ghana Cedi', value: 'GHS' },
  { name: 'GIP — Gibraltar Pound', value: 'GIP' },
  { name: 'GMD — Dalasi', value: 'GMD' },
  { name: 'GNF — Guinean Franc', value: 'GNF' },
  { name: 'GTQ — Quetzal', value: 'GTQ' },
  { name: 'GYD — Guyana Dollar', value: 'GYD' },
  { name: 'HKD — Hong Kong Dollar', value: 'HKD' },
  { name: 'HNL — Lempira', value: 'HNL' },
  { name: 'HTG — Gourde', value: 'HTG' },
  { name: 'HUF — Forint', value: 'HUF' },
  { name: 'IDR — Rupiah', value: 'IDR' },
  { name: 'ILS — New Israeli Sheqel', value: 'ILS' },
  { name: 'INR — Indian Rupee', value: 'INR' },
  { name: 'IQD — Iraqi Dinar', value: 'IQD' },
  { name: 'IRR — Iranian Rial', value: 'IRR' },
  { name: 'ISK — Iceland Krona', value: 'ISK' },
  { name: 'JMD — Jamaican Dollar', value: 'JMD' },
  { name: 'JOD — Jordanian Dinar', value: 'JOD' },
  { name: 'JPY — Yen', value: 'JPY' },
  { name: 'KES — Kenyan Shilling', value: 'KES' },
  { name: 'KGS — Som', value: 'KGS' },
  { name: 'KHR — Riel', value: 'KHR' },
  { name: 'KMF — Comorian Franc', value: 'KMF' },
  { name: 'KPW — North Korean Won', value: 'KPW' },
  { name: 'KRW — Won', value: 'KRW' },
  { name: 'KWD — Kuwaiti Dinar', value: 'KWD' },
  { name: 'KYD — Cayman Islands Dollar', value: 'KYD' },
  { name: 'KZT — Tenge', value: 'KZT' },
  { name: 'LAK — Lao Kip', value: 'LAK' },
  { name: 'LBP — Lebanese Pound', value: 'LBP' },
  { name: 'LKR — Sri Lanka Rupee', value: 'LKR' },
  { name: 'LRD — Liberian Dollar', value: 'LRD' },
  { name: 'LSL — Loti', value: 'LSL' },
  { name: 'LYD — Libyan Dinar', value: 'LYD' },
  { name: 'MAD — Moroccan Dirham', value: 'MAD' },
  { name: 'MDL — Moldovan Leu', value: 'MDL' },
  { name: 'MGA — Malagasy Ariary', value: 'MGA' },
  { name: 'MKD — Denar', value: 'MKD' },
  { name: 'MMK — Kyat', value: 'MMK' },
  { name: 'MNT — Tugrik', value: 'MNT' },
  { name: 'MOP — Pataca', value: 'MOP' },
  { name: 'MRU — Ouguiya', value: 'MRU' },
  { name: 'MUR — Mauritius Rupee', value: 'MUR' },
  { name: 'MVR — Rufiyaa', value: 'MVR' },
  { name: 'MWK — Malawi Kwacha', value: 'MWK' },
  { name: 'MXN — Mexican Peso', value: 'MXN' },
  { name: 'MYR — Malaysian Ringgit', value: 'MYR' },
  { name: 'MZN — Mozambique Metical', value: 'MZN' },
  { name: 'NAD — Namibia Dollar', value: 'NAD' },
  { name: 'NGN — Naira', value: 'NGN' },
  { name: 'NIO — Cordoba Oro', value: 'NIO' },
  { name: 'NOK — Norwegian Krone', value: 'NOK' },
  { name: 'NPR — Nepalese Rupee', value: 'NPR' },
  { name: 'OMR — Rial Omani', value: 'OMR' },
  { name: 'PAB — Balboa', value: 'PAB' },
  { name: 'PEN — Sol', value: 'PEN' },
  { name: 'PGK — Kina', value: 'PGK' },
  { name: 'PHP — Philippine Peso', value: 'PHP' },
  { name: 'PKR — Pakistan Rupee', value: 'PKR' },
  { name: 'PLN — Zloty', value: 'PLN' },
  { name: 'PYG — Guarani', value: 'PYG' },
  { name: 'QAR — Qatari Rial', value: 'QAR' },
  { name: 'RON — Romanian Leu', value: 'RON' },
  { name: 'RSD — Serbian Dinar', value: 'RSD' },
  { name: 'RUB — Russian Ruble', value: 'RUB' },
  { name: 'RWF — Rwanda Franc', value: 'RWF' },
  { name: 'SAR — Saudi Riyal', value: 'SAR' },
  { name: 'SBD — Solomon Islands Dollar', value: 'SBD' },
  { name: 'SCR — Seychelles Rupee', value: 'SCR' },
  { name: 'SDG — Sudanese Pound', value: 'SDG' },
  { name: 'SEK — Swedish Krona', value: 'SEK' },
  { name: 'SGD — Singapore Dollar', value: 'SGD' },
  { name: 'SHP — Saint Helena Pound', value: 'SHP' },
  { name: 'SLE — Leone', value: 'SLE' },
  { name: 'SOS — Somali Shilling', value: 'SOS' },
  { name: 'SRD — Surinam Dollar', value: 'SRD' },
  { name: 'SSP — South Sudanese Pound', value: 'SSP' },
  { name: 'STN — Dobra', value: 'STN' },
  { name: 'SVC — El Salvador Colon', value: 'SVC' },
  { name: 'SYP — Syrian Pound', value: 'SYP' },
  { name: 'SZL — Lilangeni', value: 'SZL' },
  { name: 'THB — Baht', value: 'THB' },
  { name: 'TJS — Somoni', value: 'TJS' },
  { name: 'TMT — Turkmenistan New Manat', value: 'TMT' },
  { name: 'TND — Tunisian Dinar', value: 'TND' },
  { name: 'TOP — Pa’anga', value: 'TOP' },
  { name: 'TRY — Turkish Lira', value: 'TRY' },
  { name: 'TTD — Trinidad and Tobago Dollar', value: 'TTD' },
  { name: 'TWD — New Taiwan Dollar', value: 'TWD' },
  { name: 'TZS — Tanzanian Shilling', value: 'TZS' },
  { name: 'UAH — Hryvnia', value: 'UAH' },
  { name: 'UGX — Uganda Shilling', value: 'UGX' },
  { name: 'UYU — Peso Uruguayo', value: 'UYU' },
  { name: 'UZS — Uzbekistan Sum', value: 'UZS' },
  { name: 'VES — Bolívar Soberano', value: 'VES' },
  { name: 'VND — Dong', value: 'VND' },
  { name: 'VUV — Vatu', value: 'VUV' },
  { name: 'WST — Tala', value: 'WST' },
  { name: 'XAF — CFA Franc BEAC', value: 'XAF' },
  { name: 'XCD — East Caribbean Dollar', value: 'XCD' },
  { name: 'XCG — Caribbean Guilder', value: 'XCG' },
  { name: 'XOF — CFA Franc BCEAO', value: 'XOF' },
  { name: 'XPF — CFP Franc', value: 'XPF' },
  { name: 'YER — Yemeni Rial', value: 'YER' },
  { name: 'ZAR — Rand', value: 'ZAR' },
  { name: 'ZMW — Zambian Kwacha', value: 'ZMW' },
  { name: 'ZWG — Zimbabwe Gold', value: 'ZWG' },
];
